export default "__VITE_ASSET__Jte021eT__"